import ArticleContent from 'components/pages/blog/ArticleContent'
import BackToList from 'components/shared/BackToList'
import SliceManager from 'components/shared/SliceManager'
import IntegrationTopics from 'components/shared/IntegrationTopics'
import delve from 'dlv'
import React from 'react'
import { getDataDependencies, buildStaticPaths } from 'services/api'
import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'

import PreviewBanner from 'src/components/shared/PreviewBanner'
import fetchContentType from 'src/lib/Strapi/fetchContentType'

const Integration = ({ pageData, preview }) => {
  const {
    title,
    description,
    seo,
    image,
    publishedAt,
    user,
    content,
    slices,
    url,
    integration_topics,
  } = pageData

  const metaTitle = delve(seo, 'metaTitle')
  const metaDescription = delve(seo, 'metaDescription')

  return (
    <>
      {preview && <PreviewBanner />}
      <div className="container">
        <BackToList
          text="Back to integrations"
          url={url}
          contentType="single"
        />
        <ArticleContent
          theme="purple"
          title={title ? `Integrate ${title} with Strapi` : metaTitle}
          subtitle={description || metaDescription}
          image={image}
          author={{
            name: delve(user, 'username'),
            description: delve(user, 'description'),
            job: delve(user, 'job.name'),
            date: publishedAt,
            image: delve(user, 'avatar'),
          }}
          content={
            `***These integration guides are not official documentation and the Strapi Support Team will not provide assistance with them***.\n\n` +
            content
          }
          comments={false}
        />

        {slices && <SliceManager slices={slices} />}
        {integration_topics && (
          <IntegrationTopics topics={integration_topics} integration={title} />
        )}
      </div>
    </>
  )
}

export async function getStaticPaths() {
  const data = await fetchAllSlugs('integrations')
  return buildStaticPaths(data, 'integrations')
}

export async function getStaticProps({ preview = null, params }) {
  const data = await fetchContentType(
    'integrations',
    `filters[slug]=${params.slug}${
      preview ? '&publicationState=preview' : ''
    }`
  )
  const pageData = await getDataDependencies(delve(data, '0'))

  if (data?.length === 0 || !data) {
    return {
      props: {},
      notFound: true,
    }
  }

  return {
    props: {
      pageData: {
        ...pageData,
        url: '/integrations',
      },
      preview,
    },
  }
}

export default Integration
